import React from 'react';
import { useTranslation } from 'react-i18next';
import { HStack, Panel, ToggleButtons } from '@lib/ui-components';
import { ClientCommercialDoc } from './client-commercial-doc';
import { ClientOtherFiles } from './client-other-files';
import { CompanyViewModel } from '@lib/api-interface';

export interface ClientFilesProps {
  company: CompanyViewModel;
}

export const ClientFiles = (props: ClientFilesProps) => {
  const { t } = useTranslation();
  const [activePage, setActivePage] = React.useState(0);

  return (
    <Panel borderType='raised'>
      <HStack align='center'>
        <ToggleButtons labels={[t('commercialDocument'), t('otherFiles')]} activeIndex={activePage} onChange={(index) => setActivePage(index)} />
      </HStack>

      {activePage === 0 && <ClientCommercialDoc company={props.company} />}
      {activePage === 1 && <ClientOtherFiles company={props.company} />}
    </Panel>
  );
};
